'use strict';

var resolution = {
	Set: null,
	Switch: null,
	orientation: null,
	current: null,
	first: true
};

var sitewide = {
	search: {
		open: function open() {
			var $this = $('#search');
			if (!$this.hasClass('active') && !$this.hasClass('busy')) {
				var width = $(window).width() - $('#logo').width(),
				    $form = $this.find('form');
				if (Modernizr.mq('(max-width: 759px)')) {
					width = $(window).width();
				}
				$this.addClass('busy');
				$form.css({ 'width': width }).addClass('active');
				$this.css({ 'width': width }).addClass('active');
				$form.find('input[type="text"]').focus();
				setTimeout(function () {
					$this.removeClass('busy');
				}, 300);
			}
		},
		close: function close() {
			var $this = $('#search');
			if ($this.hasClass('active') && !$this.hasClass('busy')) {
				var $form = $this.find('form');
				$this.addClass('busy');
				$this.css({ 'width': 0 }).removeClass('active');
				setTimeout(function () {
					$form.removeClass('active').css({ 'width': 0 });
					$this.removeClass('busy');
				}, 300);
			}
		},
		resize: function resize() {
			var $this = $('#search');
			if ($this.hasClass('active')) {
				var width = $(window).width() - $('#logo').width(),
				    $form = $this.find('form');
				if (Modernizr.mq('(max-width: 759px)')) {
					width = $(window).width();
				}
				$form.css({ 'width': width });
				$this.css({ 'width': width });
			}
		}
	},
	mobMenu: {
		active: false,
		busy: false,
		open: function open() {
			if (sitewide.mobMenu.active == false && sitewide.mobMenu.busy == false) {
				sitewide.mobMenu.active = true;
				sitewide.mobMenu.busy = true;
				scroller.lock(true);
				$('#menu-button').addClass('active');
				$('#mob-menu').addClass('show');
				setTimeout(function () {
					$('body').icons.init('.svg-icon', $('#mob-menu'));
					$('#mob-menu').addClass('active');
					setTimeout(function () {
						sitewide.mobMenu.busy = false;
					}, 200);
				}, 100);
			}
		},
		close: function close() {
			if (sitewide.mobMenu.active == true && sitewide.mobMenu.busy == false) {
				sitewide.mobMenu.active = false;
				sitewide.mobMenu.busy = true;
				scroller.lock(false);
				$('#menu-button').removeClass('active');
				$('#mob-menu').removeClass('active');
				setTimeout(function () {
					$('#mob-menu').removeClass('show');
					sitewide.mobMenu.busy = false;
				}, 300);
			}
		},
		toggle: function toggle() {
			if (sitewide.mobMenu.active == false) {
				sitewide.mobMenu.open();
			} else {
				sitewide.mobMenu.close();
			}
		}
	},
	init: function init() {
		$('#search-button').click(function (e) {
			e.preventDefault();
			sitewide.search.open();
		});
		$('#close-search-button').click(function (e) {
			e.preventDefault();
			sitewide.search.close();
		});
		$('#menu-button').click(function (e) {
			e.preventDefault();
			sitewide.mobMenu.toggle();
		});
	}
};

var footer = {
	scrollToTop: function scrollToTop() {
		if ($(window).scrollTop() != 0) {
			$("html, body").animate({ scrollTop: "0" }, 500);
		}
	},
	init: function init() {
		$('#scroll-to-top').click(function (e) {
			e.preventDefault();
			footer.scrollToTop();
		});
	}
};

var share = {
	toggle: function toggle($this) {
		if (!$this.hasClass('active')) {
			$this.addClass('active');
		} else {
			$this.removeClass('active');
		}
	},
	init: function init() {
		$('.shares').on("click", ".share-button", function (e) {
			e.preventDefault();
			share.toggle($(this).parents('.shares'));
		});
		$(document).on('click', function (e) {
			if ($('.shares.active').length != '') {
				if ($(e.target).closest(".shares").length === 0) {
					$('.shares.active').removeClass('active');
				}
			}
		});
	}
};

var accordeon = {
	create: function create($this) {
		$this.accordion({
			active: false,
			collapsible: true,
			header: '.question',
			heightStyle: 'content',
			icons: false
		});
	},
	init: function init() {
		$(".accordeon").each(function () {
			accordeon.create($(this));
		});
	}
};

var anchors = {
	scrollTo: function scrollTo(block) {
		var number = parseInt(block.replace('#block=', '')),
		    $this = $('#the-content-block-' + number);
		if ($this.length != '') {
			var offset = $this.offset().top - 24;
			$("html, body").animate({ scrollTop: offset }, 500);
		}
	},
	init: function init() {
		$('.the-content-block-anchors ul li a.current').click(function (e) {
			e.preventDefault();
			var block = $(this).attr('href');
			anchors.scrollTo(block);
		});
		var hash = window.location.hash;
		if (hash.includes("block")) {
			setTimeout(function () {
				anchors.scrollTo(hash);
			}, 1000);
		}
	}
};

var scroller = {
	loaded: false,
	active: true,
	lockPos: 0,
	pos: {
		curr: null,
		last: null,
		dir: null
	},
	sitewide: {
		$this: null,
		sticky: false,
		changed: false,
		height: 0
	},
	init: function init() {
		scroller.loaded = true;
		var scrollTimer = false;
		scroller.sitewide.$this = $('#sitewide');
		scroller.sitewide.height = $('#hero').outerHeight(true) + $('#hero').offset().top;
		$(window).scroll(function () {
			if (Modernizr.raf) {
				clearTimeout($.data(this, 'timer'));
				if (scrollTimer == false) {
					scrollTimer = true;
					scroller.RAF.start();
				}
				$.data(this, 'timer', setTimeout(function () {
					scrollTimer = false;
					scroller.RAF.stop();
				}, 100));
			} else {
				scroller.RAF.loop();
			}
		});
	},
	callculation: function callculation(pos) {
		if (scroller.loaded == true && scroller.active == true) {
			if (pos.dir == 'up' || pos.curr <= scroller.sitewide.height) {
				if (scroller.sitewide.sticky == true) {
					scroller.sitewide.sticky = false;
					scroller.sitewide.changed = true;
				}
			} else {
				if (scroller.sitewide.sticky == false) {
					scroller.sitewide.sticky = true;
					scroller.sitewide.changed = true;
				}
			}
		}
	},
	animation: function animation(pos) {
		if (scroller.loaded == true && scroller.active == true) {
			if (scroller.sitewide.changed == true) {
				scroller.sitewide.changed = false;
				if (scroller.sitewide.sticky == true) {
					scroller.sitewide.$this.addClass('up');
				} else {
					scroller.sitewide.$this.removeClass('up');
				}
			}
		}
	},
	resize: function resize() {
		if (scroller.loaded == true) {
			scroller.sitewide.height = $('#hero').outerHeight(true) + $('#hero').offset().top;
		}
	},
	RAF: {
		ID: null,
		loop: function loop() {
			if (!$('body').hasClass('fixed')) {
				scroller.pos.curr = Math.round($(window).scrollTop());
				if (scroller.pos.curr < 0) {
					scroller.pos.curr = 0;
				}
				if (scroller.pos.curr > scroller.pos.last) {
					scroller.pos.dir = 'down';
				} else if (scroller.pos.curr < scroller.pos.last) {
					scroller.pos.dir = 'up';
				}
				scroller.callculation(scroller.pos);
				scroller.animation(scroller.pos);
				scroller.pos.last = scroller.pos.curr;
				if (Modernizr.raf) {
					scroller.RAF.ID = window.requestAnimationFrame(scroller.RAF.loop);
				}
			}
		},
		start: function start() {
			if (!scroller.RAF.ID && scroller.loaded == true) {
				scroller.RAF.loop();
			}
		},
		stop: function stop() {
			if (scroller.RAF.ID) {
				window.cancelAnimationFrame(scroller.RAF.ID);
				scroller.RAF.ID = undefined;
			}
		}
	},
	lock: function lock(stat) {
		if (stat == true) {
			scroller.lockPos = $(window).scrollTop();
			$('#container').addClass('sticky').css({ 'top': -Math.abs(scroller.lockPos) });
			scroller.active = false;
		} else {
			$('#container').removeClass('sticky').removeAttr('style');
			$(window).scrollTop(scroller.lockPos);
			setTimeout(function () {
				scroller.active = true;
			}, 500);
		}
	}
};

var gallery = {
	init: function init() {
		$('.gallery figure a').click(function (e) {
			e.preventDefault();
		});
	}
};

$(function () {

	// icons
	$('body').icons({
		svg: customData.themePath + '/img/output/sprite.svg',
		offset: 2,
		ajax: true,
		testFallback: false,
		ready: function ready(prop) {}
	});
	$('body').icons.init('.svg-icon');

	// image loader
	$('.load-img').imageLoader({
		ready: function ready(prop) {
			// console.log('done!');
		},
		resize: function resize(prop) {
			// console.log('resize');
		}
	});

	// youtube
	function scaleYoutube() {
		$('.the-content .embed iframe').each(function () {
			$(this).attr('width', 'auto').attr('height', 'auto');
			var width = $('.the-content').width(),
			    height = width / 16 * 11;
			$(this).attr('width', width).attr('height', height);
		});
	}

	// switch grid / resize functions
	resolution.Switch = function (size) {
		if (resolution.first === true) {
			resolution.first = false;
			defaultResets.init();
			scaleYoutube();
			sitewide.init();
			footer.init();
			share.init();
			accordeon.init();
			scroller.init();
			anchors.init();
			gallery.init();
		} else {
			$('body').icons.init('.svg-icon');
		}
	};

	var resizeTimeout;
	$(window).resize(function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			resolution.Set();
			scaleYoutube();
			$('.load-img').imageLoader.resize();
			sitewide.search.resize();
			scroller.resize();
		}, 100);
	});

	resolution.orientation = function () {};
	window.addEventListener('orientationchange', resolution.orientation);

	resolution.Set();
});

// switch grid / resize functions
resolution.Set = function () {
	var newResolution;
	/*
 760
 1020
 1280
 1440
 */
	if (Modernizr.mq('(max-width: 759px)')) {
		newResolution = 'mobile';
	} else if (Modernizr.mq('(max-width: 1019px)')) {
		newResolution = 'tablet portrait'; // 760
	} else if (Modernizr.mq('(max-width: 1279px)')) {
		newResolution = 'tablet landscape'; // 1020
	} else if (Modernizr.mq('(max-width: 1439px)')) {
		newResolution = 'desktop'; //1280
	} else {
		newResolution = 'desktop wide'; //1440
	}
	if (newResolution != resolution.current) {
		var resolutionClasses = ['mobile', 'tablet', 'desktop', 'wide', 'portrait', 'landscape'];
		$.each(resolutionClasses, function (i, v) {
			$('html').removeClass(v);
		});
		resolution.current = newResolution;
		$('html').addClass(resolution.current);
		resolution.Switch(resolution.current);
	}
};
$('#setGrid').ready(function () {
	resolution.Set();
});